const buildCssGF = (styles = {}) => {
  return Object.entries(styles)
    .map(([k, v]) => `${k}: ${v};`)
    .join("\n");
};

export { buildCssGF };
